import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=c32b47a4&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32b47a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c32b47a4')) {
      api.createRecord('c32b47a4', component.options)
    } else {
      api.reload('c32b47a4', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=c32b47a4&scoped=true&", function () {
      api.rerender('c32b47a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2K89EFl6jvOKG/JS/comp/Voucher-Unit.vue"
export default component.exports